// extracted by mini-css-extract-plugin
export var sectionContainer = "CategoriesList-module--sectionContainer--1WtZ1";
export var headerTitle = "CategoriesList-module--headerTitle--tnlEs";
export var subjectContainer = "CategoriesList-module--subjectContainer--30w7R";